import React, { useState, useEffect } from 'react';
import Layout from '../../components/layout';
import Heading from '../../components/heading';
import Seo from '../../components/seo';
import { scaleBand, scaleLinear } from 'd3-scale';
import { max } from 'd3-array';
import Bar1 from '../../components/Bar1';
import { csv } from 'd3-fetch';
import { descending } from 'd3-array';
import { graphql } from 'gatsby';
import { format } from 'd3-format';
import Body from '../../components/body';
import Code from '../../components/code';
import Url from '../../components/url';


const HorizontalBar3 = ({ data }) => {
    const location = data.allFile.nodes[0].publicURL
    const margin = ({ top: 40, bottom: 20, left: 40, right: 20 })
    const [datas, setDatas] = useState(null)
    const [width, setWidth] = useState(400)
    const height = 600;
    const updateDimensions = () => {
        setWidth(window.outerWidth);
    }
    useEffect(() => {
        const format = ({ letter, frequency }) => (
            {
                name: letter,
                count: +frequency
            })
        csv(location, format).then(value => {
            value.sort((a, b) => descending(a.count, b.count))
            setDatas(value)
        })
    }, [location])
    useEffect(() => {
        setWidth(window.outerWidth);
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    }, []);
    const xScale = datas ? scaleLinear()
        .domain([0, max(datas, d => d.count)])
        .range([0, width - 3 * margin.right - margin.left - 20])
        : null
    const yScale = datas ? scaleBand()
        .domain(datas.map(d => d.name))
        .range([margin.top, height - margin.bottom])
        .padding(0.3)
        : null
    return (
        <Layout>
            <Seo title="HorizontalBar Charts-II" />
            <Heading heading="HorizontalBar Chart-III" />
            <Body>
                <p>In the last chapter we made horizontal Bar charts with 3-data points and colors.
                    Today we will look at how to export data and build chart.
                    <br />
                    <br />
                    We have a data set which is in the file
                    <Url href="alphabets github jist" 
                        url="https://raw.githubusercontent.com/thegazettedata/d3charts/master/projects/cr-bike-trails/data/letter-frequency.csv" name="alphabets.csv"/>
                    it is the list of frequency of alphabets in english language from 40,000 samples .We will read the csv file with d3 csv and will follow the same pattern
                    as we did before. xAxis will be the frequency chart and yAxis will be the letters.
                </p>
                <Code>
                    {`const fruits=
    [
        { name: "🍊", count: 21 },
        { name: "🍇", count: 13 },
        { name: "🍏", count: 8 },
        { name: "🍌", count: 5 },
        { name: "🍐", count: 3 },
        { name: "🍋", count: 2 },
        { name: "🍎", count: 1 },
        { name: "🍉", count: 1 }
    ] `}
                </Code>
                <p>
                    The above dataset is what I started with. Since I am using react so I have
                    made horizontal bar chart components that takes the data which is in the above format.
                    So after importing data I will have to convert the data into above format using the d3 csv tool.
                </p>
                <Code>
                    {`d3.csv(location,formating function)
    .then(doSomething)`}
                </Code>
                <p>
                    The above code needs to be inside the react useEffect hook so that it doesn't keep
                    on calling the data.
                </p>
                <Code>
                    {`useEffect(() => {
    const format = 
        ({ letter, frequency }) => ({
            name: letter,
            value: +frequency
        })
    csv('/alphabet.csv', format).then(value => {
        value.sort(
            (a, b) => descending(a.count, b.count)
        )
        setData(value)})
    }, [])`}
                </Code>
                <p>
                    The format function is used to process the data to be similar to fruits. Then I am using
                    d3's descending function to arrange the data in descending order.
                </p>
                {
                    datas
                        ?
                        <div className="my-2 sm:my-4 border dark:bg-gray-500 bg-gray-200 rounded">
                            <Bar1
                                format={format('.0%')}
                                xIndex='Frequency'
                                yIndex='Letters'
                                data={datas}
                                width={width}
                                height={height}
                                xScale={xScale}
                                yScale={yScale}
                                margin={margin} />
                        </div>
                        :
                        <pre> Loading..... </pre>}
                <p>
                    There is one tricks used here to make the data look nice. The frequency data
                    has been formatted to percentage for better readability.
                </p>
                <Code>
                    {`d3.format('.0%)(.0819)`}
                </Code>
                <p>
                    The graph can be formatted better and the percentage adjusted for the 0%. But since I am
                    using a common component so I will leave those for next time.
                </p>
            </Body>
        </Layout >
    )
}

export const query = graphql`
    query HorizontalBar3Query {
        allFile(filter: {base: {regex: "/.*alphabets.*/"}}) {
            nodes {
              publicURL
            }
        }
    }
`

export default HorizontalBar3